import React from 'react';
import ContactForm from '../../../components/ContactForm/ContactForm';

const BloodTestContactForm = ({ variant = 'dark' }) => (
  <div className="pb-20">
    <div className="d-flex parent-form">
      <div className="img-left-form">
        <div
          style={{ backgroundImage: 'url(/assets/icons/form-img.jpg)', backgroundSize: 'cover' }}
          className="pos-leftimg"
        />
      </div>
      <div className="container">
        <div className="py-md-15 py-10 right-form-cs">
          <h4 className="text-white">
            Have a question? <br /> Drop us a line!
          </h4>
          <ContactForm
            idPrefix="bt-legacy-contact"
            variant={variant === 'dark' ? 'dark' : undefined}
            className="pt-md-15 pt-10"
            submitLabel="SEND MESSAGE"
            sendingLabel="Please wait..."
            textareaRows={12}
          />
        </div>
      </div>
    </div>
  </div>
);

export { BloodTestContactForm };
